var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(parseInt(_vm.s.subscription_type) === 2)?[_vm._v("---")]:[_vm._v(" "+_vm._s(_vm.$n(_vm.s.amount, { style: "currency", currency: _vm.s.currency, currencyDisplay: "code" }))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }